import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import Society from './scenes/Society/containers';
import Event from './scenes/Event/containers';

import reduxStore from './reduxStore';
import withSocket from './components/Session/withSocket';
import SocketContext from './components/Session/SocketContext';
import withAuthentication from './components/Session/withAuthentication';
import withTheme from './components/Theme/withTheme';
import NetworkDetector from './NetworkDetector';
import withPlatformInfoUpdates from './scenes/User/components/platformInfo/PlatformInfoContextProvider';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { ContainerProvider } from './scenes/VirtualModeration/features/virtualFeature/containers/main';
import CookieNoticeWrapper from './components/Session/CookieNoticeWrapper';

export const CONNECTION_ERROR_MESSAGE = 'Could not connect to server';
export const EVENT_NOT_FOUND_MESSAGE = 'AppState not found';
export const EVENT_NOT_CONFIGURED_MESSAGE = 'Navigation not configured';
export const USER_NOT_ATTENDING_PERMISSIONS = 'User not in attendees';

function App() {
    return (
        <ContainerProvider>
            <Provider store={reduxStore}>
                <Switch>
                    <Route path="/event/:eventName">
                        <Event />
                    </Route>
                    <Route path="/kiosk/:eventName">
                        <Event kiosk />
                    </Route>
                    <Route path="/">
                        <Society />
                    </Route>
                </Switch>
            </Provider>
        </ContainerProvider>
    );
}

//Pass set theme function in the app component
const AppWithSocketAndUpdates = props => {
    useEffect(() => {
        if (!props.waitingWorker) {
            serviceWorkerRegistration.register({
                onUpdate: reg => props.onServiceWorkerUpdate(reg),
                onSuccess: () => {},
            });
        }
    }, [props.newVersionAvailable]);

    return (
        <SocketContext.Consumer>
            {({ socket }) => socket && <App {...props} socket={socket} />}
        </SocketContext.Consumer>
    );
};

const AppWithRouter = withTheme(withPlatformInfoUpdates(AppWithSocketAndUpdates));

const AppWithCookiesEnabled = props => {
    return (
        <CookieNoticeWrapper>
            <AppWithRouter {...props} />
        </CookieNoticeWrapper>
    );
};

//Add Authentication context
export default NetworkDetector(withSocket(withAuthentication(AppWithCookiesEnabled)));
